import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function indicationDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return (<string>control.value)
      .toLocaleLowerCase()
      .indexOf(`date - publication`) >= 0
      ? { invalidIndication: { value: control.value } }
      : null;
  };
}

export class KeywordValidator {
  private static conditionsRegex = /(\b(?:AND|OR|NOT)\b)+/;

  private static stringRegex = /^(?:[a-zA-Z0-9\s'-]+)$/;
  private static quotesRegex = /^\"(?:[a-zA-Z0-9\s'-]+)\"$/;
  private static singleQuotesRegex = /^\"(?:[a-zA-Z0-9\s'-]+)\"$/;
  private static parenthesisRegex = /^\((?:[a-zA-Z0-9\s'-]+)\)$/;

  // keyword string is valid if is a simple text
  // may have parenthesis or quotes only if both are present
  private static isKeywordStringValid = (value: string): boolean => {
    return (
      this.stringRegex.test(value) ||
      this.quotesRegex.test(value) ||
      this.singleQuotesRegex.test(value) ||
      this.parenthesisRegex.test(value)
    );
  };

  // keywords can be separated with AND, OR, NOT
  private static hasConditions = (value: string): boolean => {
    return value.match(this.conditionsRegex) !== null;
  };

  // Split only on top-level boolean operators (not inside parentheses)
  private static splitTopLevel = (value: string): string[] => {
    const parts: string[] = [];
    let depth = 0;
    let current = '';
    let i = 0;
    while (i < value.length) {
      if (depth === 0) {
        const match = value.substring(i).match(/^(AND|OR|NOT)\b/);
        if (match) {
          if (current.trim()) parts.push(current.trim());
          parts.push(match[1]);
          current = '';
          i += match[1].length;
          continue;
        }
      }
      if (value[i] === '(') depth++;
      else if (value[i] === ')') depth--;
      current += value[i];
      i++;
    }
    if (current.trim()) parts.push(current.trim());
    return parts;
  };

  private static isKeywordFormatValid = (value: string): boolean => {
    const parts = this.splitTopLevel(value);
    const hasTopLevelConditions = parts.some(p => /^(?:AND|OR|NOT)$/.test(p));
    if (hasTopLevelConditions) {
      return parts.every(p =>
        /^(?:AND|OR|NOT)$/.test(p) || this.isKeywordFormatValid(p.trim())
      );
    }
    return this.isKeywordStringValid(value);
  };

  public static keywordsFormatValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (this.isKeywordFormatValid(control.value)) {
        return null;
      }
      return { invalidFormat: true };
    };
  }
}
